module.exports = __webpack_public_path__ + "f8a284a89f59e736851346118b83c15d.svg";